"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stepper = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("../../styles");
var util_1 = require("../../util");
var overrides_1 = require("../../util/overrides");
var useStepperContext_1 = require("./useStepperContext");
function Stepper(props) {
    var _a = props.direction, direction = _a === void 0 ? 'horizontal' : _a, gap = props.gap, style = props.style, overrides = props.overrides, children = props.children, rest = __rest(props, ["direction", "gap", "style", "overrides", "children"]);
    var Root = overrides_1.getComponents(overrides, defaultComponents).Root;
    var stepCounterRef = react_1.useRef(0);
    var steps = react_1.useMemo(function () {
        return react_1.Children.toArray(children).filter(function (child) { return react_1.isValidElement(child) && typeof child.type === 'function'; });
    }, [children]);
    var stepStatuses = react_1.useMemo(function () { return steps.map(function (child) { var _a; return (_a = child.props.status) !== null && _a !== void 0 ? _a : 'incompleted'; }); }, [steps]);
    var _b = styles_1.useStyles(createStyles, direction, gap, steps.length), classes = _b.classes, css = _b.css;
    var incrementStep = react_1.useCallback(function () {
        var currentIndex = stepCounterRef.current;
        stepCounterRef.current += 1;
        return currentIndex;
    }, []);
    var stepperContextValue = react_1.useMemo(function () { return ({
        direction: direction,
        gap: gap,
        incrementStep: incrementStep,
        getNextStepStatus: function (currentIndex) { return stepStatuses[currentIndex + 1]; },
    }); }, [gap, direction, incrementStep, stepStatuses]);
    return (react_1.default.createElement(useStepperContext_1.StepperContextProvider, { value: stepperContextValue },
        react_1.default.createElement(Root, __assign({ className: css(classes.stepper, style) }, rest), children)));
}
exports.Stepper = Stepper;
var defaultComponents = {
    Root: 'div',
};
var createStyles = function (_theme, direction, gap, numberOfSteps) {
    var isHorizontal = direction === 'horizontal';
    var isVertical = direction === 'vertical';
    var hasGap = !util_1.isNil(gap);
    return {
        stepper: {
            width: hasGap && 'max-content',
            height: isVertical && '100%',
            display: 'grid',
            alignItems: isHorizontal && 'flex-start',
            gap: hasGap && gap + "rem",
            gridTemplateRows: isVertical && "repeat(" + (numberOfSteps - 1) + ", " + (hasGap ? 'min-content' : 'auto') + ") min-content",
            gridTemplateColumns: isHorizontal && "repeat(" + numberOfSteps + ", 1fr)",
        },
    };
};
//# sourceMappingURL=Stepper.js.map